/* rhoneprints glitch: hover scramble on text, glitching name, occasional image bursts */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  var CHARS = 'cats#%&/_01|<>*+=~';

  /* --- header name: "rhone", glitching --- */
  function setupName() {
    var link = document.querySelector('.header__heading-link');
    if (!link) return;
    var el = link.querySelector('.h2') || link.querySelector('span');
    if (!el) {
      el = document.createElement('span');
      el.className = 'h2';
      link.textContent = '';
      link.appendChild(el);
    }
    el.textContent = 'rhone';
    el.classList.add('glitch');
    el.setAttribute('data-text', 'rhone');
    el.setAttribute('data-gl-auto', '9');
  }
  setupName();
  root.classList.add('gl-ready');
  if (reduce) return;

  /* --- text scramble engine --- */
  var SKIP = 'input, select, textarea, script, style, noscript, .price, .money, .quantity, .cart-count-bubble, .product-form__input, .variant-picker, variant-selects, [data-gl-skip], .cat-card__color, .visually-hidden';
  var BLOCKS = 'a, button, h1, h2, h3, h4, h5, h6, p, li, label, summary, legend, dt, dd, th, td, .button';
  var busy = new WeakSet();

  function textNodes(el) {
    var out = [];
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      if (!n.nodeValue || !n.nodeValue.trim()) continue;
      if (n.parentNode && n.parentNode.closest && n.parentNode.closest(SKIP)) continue;
      out.push(n);
    }
    return out;
  }

  function scramble(el) {
    if (!el || busy.has(el)) return;
    var nodes = textNodes(el);
    if (!nodes.length) return;
    var origs = nodes.map(function (n) { return n.nodeValue; });
    var hasData = el.hasAttribute('data-text');
    busy.add(el);
    el.classList.add('gl-scr');
    var step = 0;
    var steps = 8;
    var iv = setInterval(function () {
      step++;
      var done = step >= steps;
      var joined = '';
      nodes.forEach(function (n, k) {
        var o = origs[k];
        if (done) { n.nodeValue = o; joined += o; return; }
        var s = '';
        for (var i = 0; i < o.length; i++) {
          var c = o.charAt(i);
          if (/[a-z0-9]/i.test(c) && Math.random() < 0.45 * (1 - step / (steps + 1)) + 0.15) {
            s += CHARS.charAt(Math.floor(Math.random() * CHARS.length));
          } else { s += c; }
        }
        n.nodeValue = s;
        joined += s;
      });
      if (hasData) el.setAttribute('data-text', joined);
      if (done) {
        clearInterval(iv);
        el.classList.remove('gl-scr');
        busy.delete(el);
      }
    }, 45);
  }
  window.glScramble = scramble;

  function pick(target) {
    if (!target || !target.closest) return null;
    var cands = [target.closest(BLOCKS), target.closest('.glitch'), target.closest('span, strong, em, b')];
    for (var i = 0; i < cands.length; i++) {
      var c = cands[i];
      if (c && !c.closest(SKIP) && c.textContent.length <= 400 && c.textContent.trim()) return c;
    }
    return null;
  }

  var last = null;
  document.addEventListener('mouseover', function (e) {
    var el = pick(e.target);
    if (!el || el === last) return;
    last = el;
    scramble(el);
  }, { passive: true });
  document.addEventListener('mouseout', function () { last = null; }, { passive: true });
  document.addEventListener('focusin', function (e) { var el = pick(e.target); if (el) scramble(el); });

  /* --- auto scramble on load and every so often for [data-gl-auto] --- */
  function auto() {
    var els = document.querySelectorAll('[data-gl-auto]');
    Array.prototype.forEach.call(els, function (el) {
      var every = (parseFloat(el.getAttribute('data-gl-auto')) || 6) * 1000;
      if (el.__glAuto) return;
      el.__glAuto = true;
      setTimeout(function () { scramble(el); }, 500);
      setInterval(function () { if (Math.random() < 0.6) scramble(el); }, every);
    });
  }
  auto();
  document.addEventListener('DOMContentLoaded', auto);

  /* --- image bursts on collection-page cards: gentler, every so often while hovering.
         (the home page cover posters glitch once per colorway swap instead, see index.json) --- */
  var hovered = new WeakMap();
  function burst(box) {
    box.classList.add('is-glitching');
    setTimeout(function () { box.classList.remove('is-glitching'); }, 260);
  }
  function loop(card, box) {
    var t = setTimeout(function () {
      if (!hovered.get(card)) return;
      burst(box);
      loop(card, box);
    }, 1600 + Math.random() * 2000);
    hovered.set(card, t);
  }
  function enter(e) {
    var card = e.target.closest && e.target.closest('.card-wrapper');
    if (!card || hovered.get(card)) return;
    var box = card.querySelector('.card__media');
    if (!box) return;
    burst(box);
    loop(card, box);
  }
  function leave(e) {
    var card = e.target.closest && e.target.closest('.card-wrapper');
    if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    clearTimeout(hovered.get(card));
    hovered.set(card, 0);
  }
  document.addEventListener('mouseover', enter, { passive: true });
  document.addEventListener('mouseout', leave, { passive: true });
})();
